import IWebPhoneService from '../IWebPhoneService';
import { phoneState } from '../state';
import { WebphoneCallState } from '../types';
import handleCallEnded from './handleCallEnded';
import handleCallAnswered from './handleCallAnswered';
import handleCallMissed from './handleCallMissed';
import IAppLogger from '@app/lib/IAppLogger';

const handleCallStateUpdate = async (
  webPhoneService: IWebPhoneService,
  updatedCallState: WebphoneCallState,
  logger: IAppLogger,
) => {
  const { callId } = updatedCallState;
  const currentCallState = phoneState.callList[callId];

  if (!phoneState.callList[callId]) {
    return;
  }

  // check for state changes
  const established = updatedCallState.established;

  if (!established && currentCallState.progress && !updatedCallState.progress) {
    // by the time we get here, the call has already ended
    // and the callState has been reset. send the previous call state
    handleCallMissed(webPhoneService, currentCallState, logger);
  } else if (currentCallState.established && !updatedCallState.established) {
    // by the time we get here, the call has already ended
    // and the callState has been reset. send the previous call state
    handleCallEnded(webPhoneService, currentCallState, logger);
  } else if (!currentCallState.established && updatedCallState.established) {
    handleCallAnswered(webPhoneService, currentCallState, logger);
  }

  // should be kept in sync with https://github.com/servicetitan/telecom-webphone/blob/master/packages/application/src/modules/SoftPhoneModule/state.ts

  phoneState.callList[callId] = {
    ...phoneState.callList[callId],
    ...updatedCallState,
  };
};

export default handleCallStateUpdate;
